<template>
    <div v-if="className == 'sub-tab-wrap'" class="sub-tab-wrap">
        <template v-for="item in gnbs">
            <ul class="tab tab--inline" :key="item.title" v-if="item.title == sh">
                <li v-for="child in item.children" :key="child.title" class="tab__li" :class="{ active: tabActive == child.title }">
                    <a :href="child.path" class="tab__btn"
                        ><span>{{ child.title }}</span></a
                    >
                </li>
            </ul>
        </template>
    </div>
    <ul v-else-if="className == 'gnb'" :class="className">
        <template v-for="item in gnbs">
            <li v-if="!item.children" :class="className + '__li'" :key="item.title">
                <a v-if="item.href" :href="item.href" :class="className + '__link'" target="_blank"
                    ><h2>{{ item.title }}</h2></a
                >
                <router-link v-else :to="item.path" :class="className + '__link'"
                    ><h2>{{ item.title }}</h2></router-link
                >
            </li>

            <li v-else :class="className + '__li'" :key="item.title">
                <div v-if="isMobile" :class="className + '__link gnb__link--toggle'">
                    <h2>{{ item.title }}</h2>
                </div>
                <router-link v-else :to="item.path" :class="className + '__link gnb__link--toggle'"
                    ><h2>{{ item.title }}</h2></router-link
                >
                <ul :class="className + '__sub'">
                    <li v-for="child in item.children" :key="child.title">
                        <router-link :to="child.path">{{ child.title }}</router-link>
                    </li>
                </ul>
            </li>
        </template>
    </ul>
</template>

<script>
export default {
    props: {
        className: String,
        indexNum: String,
        sh: String,
        tabActive: String,
    },
    data: function() {
        return {
            window: {
                width: 0,
                height: 0,
            },
            gnbs: [
                {
                    title: "About us",
                    path: "/aboutus/company-profile",
                    children: [
                        {
                            title: "Company Profile",
                            path: "/aboutus/company-profile",
                        },
                        {
                            title: "Certificate",
                            path: "/aboutus/certificate",
                        },
                        {
                            title: "Organization",
                            path: "/aboutus/organization",
                        },
                        {
                            title: "Location",
                            path: "/aboutus/location/paju",
                        },
                    ],
                },
                {
                    title: "Product",
                    path: "/product/Analyzer",
                    children: [
                        {
                            title: "Analyzer Package System",
                            path: "/product/Analyzer",
                        },
                        {
                            title: "CEMS / AQMS",
                            path: "/product/CEMS",
                        },
                        {
                            title: "Liquid Analyzer System",
                            path: "/product/Liquid",
                        },
                        {
                            title: "Sampling System",
                            path: "/product/Sampling",
                        },
                        {
                            title: "Corrosion Monitoring System",
                            path: "/product/Corrosion",
                        },
                    ],
                },
                {
                    title: "Project / Reference",
                    path: "/project",
                    children: [
                        {
                            title: "Project",
                            path: "/project",
                        },
                        {
                            title: "Reference",
                            path: "/reference",
                        },
                    ],
                },
                {
                    title: "Alliance",
                    path: "/alliance/#abb",
                    children: [
                        {
                            title: "ABB",
                            path: "/alliance/#abb",
                        },
                        {
                            title: "TELEDYNE",
                            path: "/alliance/#teledyne",
                        },
                        {
                            title: "PAC",
                            path: "/alliance/#pac",
                        },
                        {
                            title: "METAL SAMPLES",
                            path: "/alliance/#metal",
                        },
                        {
                            title: "EXTREL",
                            path: "/alliance/#extrel",
                        },
                    ],
                },
            ],
        };
    },
    computed: {
        isDesktop: function() {
            return this.window.width >= 1200;
        },
        isMobile: function() {
            return this.window.width < 1200;
        },
    },
    created: function() {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener("resize", this.handleResize);
    },
    mounted: function() {},
    methods: {
        handleResize: function() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
    },
};
</script>

<style scoped></style>
